'use client';

import React, { ReactNode } from 'react';
import { styled } from 'styled-components';

export type HeaderType =
  | 'h-xxl'
  | 'h-xl'
  | 'h-l'
  | 'h-m'
  | 'h-s'
  | 'h-xs'
  | 'h-xxs'
  | 'h-l-sp'
  | 'h-m-sp'
  | 'h-s-sp'
  | 'h-s-sp-title'
  | 'h-s-sp-top-title'
  | 'h-xs-sp'
  | 'h-xxs-sp'
  | 'h-footer';

type Props = {
  children: ReactNode;
  type: HeaderType;
  color?: string;
  className?: string;
  underbar?: boolean;
  inline?: boolean;
};
const Header: React.FC<Props> = (props) => {
  return (
    <Container
      color={props.color ?? 'black'}
      className={props.className}
      type={props.type}
      underbar={props.underbar}
      inline={props.inline}
    >
      {props.children}
    </Container>
  );
};

export default Header;

const Container = styled.div<{
  type: HeaderType;
  color: string;
  underbar?: boolean;
  inline?: boolean;
}>`
  color: ${({ color }) => color};
  ${({ underbar }) => {
    if (underbar) {
      return `border-bottom: 2px solid;`;
    }
  }}
  /* font-family: 'Yu Mincho'; */
  ${({ inline }) => {
    if (inline) {
      return 'display: inline;';
    }
  }}
  ${({ type }) => {
    switch (type) {
      case 'h-xxl':
        return `
          font-size: 3.5625rem;
          font-weight: 400;
          line-height: 1.25;
          letter-spacing: 0.04em;
        `;
      case 'h-xl':
        return `
          font-size: 2.8125rem;
          font-weight: 400;
          line-height: 1.25;
          letter-spacing: 0.04em;
        `;
      case 'h-l':
        return `
          font-size: 2.25rem;
          font-weight: 400;
          line-height: 1.5;
          letter-spacing: 0.04em;
      `;
      case 'h-m':
        return `
          font-size: 2rem;
          font-weight: 400;
          line-height: 1.5;
          letter-spacing: 0.04em;
        `;
      case 'h-s':
        return `
          font-size: 1.75rem;
          font-weight: 600;
          line-height: 1.5;
          letter-spacing: 0.04em;
        `;
      case 'h-xs':
        return `
          font-size: 1.5rem;
          font-weight: 400;
          line-height: 1.5;
          letter-spacing: 0.04em;
        `;
      case 'h-xxs':
        return `
            font-size: 1.25rem;
            font-weight: 600;
            line-height: 1.5;
            letter-spacing: 0.04em;
          `;
      case 'h-l-sp':
        return `
        font-size: 2rem; // mobile
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.04em;
      `;
      case 'h-m-sp':
        return `
        font-size: 1.75rem; // mobile
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.04em;
      `;
      case 'h-s-sp':
        return `
        font-size: 1.5rem; // mobile
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.04em;
      `;
      case 'h-s-sp-title':
        return `
        font-size: 1.5rem; // mobile
        font-weight: 600;
        line-height: 1;
        letter-spacing: 0.04em;
      `;
      case 'h-s-sp-top-title':
        return `
        font-size: 2rem;
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.04em;
      `;
      case 'h-xs-sp':
        return `
        font-size: 1.25rem; // mobile
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.04em;
      `;
      case 'h-xxs-sp':
        return `
          font-size: 1rem; // mobile
          font-weight: 600;
          line-height: 1.5;
          letter-spacing: 0.04em;
        `;
      case 'h-footer':
        return `
              font-size: 1.25rem;
              font-weight: 600;
              line-height: 1.25;
              letter-spacing: 0em;
              text-align: left;
              `;
      default:
        return `
          font-size: 1.875rem;
          font-weight: normal;
          line-height: 1.4;
          letter-spacing: normal;
        `;
    }
  }}
`;
